<template>
    <!-- <div class="report-side-panel bench-overview-side-panel q-box-shadow fromleft"> -->
    <div class="lft-view report-side-panel customer-engagement q-box-shadow">
        <report-header @updateEvent="updateEngagementData" @downloadEvent="exportExcel"></report-header>
        <!-- table set -->
        <div class="table-wrapper" ref="tableWrapperLap">
            <div class="master-table-head-box master-t-head-b">
                <div class="master-table-head">
                    <div class="customer-field dropdown-setter left-pos-cell" data-setter="customer">
                        <div class="master-table-text left-table-header" @click="sortTable('customer')">Customer</div>
                        <div class="master-table-opt"></div>
                        <button type="button" class="vs-con-dropdown parent-dropdown" data-getter="customer">
                            <a href.prevent class="a-icon">
                                <i :class="(customerSearch.length > 0)?'filter-icon-i-active':'filter-icon-i'"></i>
                            </a>
                        </button>
                        <Dropdown>
                            <ul>
                                <li>
                                    <input oninput="this.value = this.value.replace(/[-!$%^*_+@\s|~=`\\#{}\[\]:;'<>?,.\/]/g,'')"
                                    type="text" class="dropdown-input" placeholder="Filter"
                                           v-model="customerSearch"/>
                                </li>
                            </ul>
                        </Dropdown>
                    </div>
                    <div class="consultant-w consultant-field dropdown-setter" data-setter="consultant">
                        <div class="master-table-text left-table-header" @click="sortTable('consultant')">Consultant
                        </div>
                        <div class="master-table-opt"></div>
                        <button type="button" class="vs-con-dropdown parent-dropdown" data-getter="consultant">
                            <a href.prevent class="a-icon">
                                <i :class="(consultantSearch.length > 0)?'filter-icon-i-active':'filter-icon-i'"></i>
                                <!-- <i class="vs-icon notranslate icon-scale more-vert-24px material-icons null"></i> -->
                            </a>
                        </button>
                        <Dropdown>
                            <ul>
                                <li>
                                    <input oninput="this.value = this.value.replace(/[-!$%^*_+@\s|~=`\\#{}\[\]:;'<>?,.\/]/g,'')"
                                    type="text" class="dropdown-input" placeholder="Filter"
                                           v-model="consultantSearch"/>
                                </li>
                            </ul>
                        </Dropdown>
                    </div>
                    <div class="co-w-thone-sap dropdown-setter project-field" data-setter="project">
                        <div class="master-table-text left-table-header" @click="sortTable('project')">Project</div>
                        <div class="master-table-opt"></div>
                        <button type="button" class="vs-con-dropdown parent-dropdown" data-getter="project">
                            <a href.prevent class="a-icon">
                                <i :class="(projectSearch.length > 0)?'filter-icon-i-active':'filter-icon-i'"></i>
                                <!-- <i class="vs-icon notranslate icon-scale more-vert-24px material-icons null"></i> -->
                            </a>
                        </button>
                        <Dropdown>
                            <ul>
                                <li>
                                    <input oninput="this.value = this.value.replace(/[-!$%^*_+@\s|~=`\\#{}\[\]:;'<>?,.\/]/g,'')"
                                    type="text" class="dropdown-input" placeholder="Filter"
                                           v-model="projectSearch"/>
                                </li>
                            </ul>
                        </Dropdown>
                    </div>
                    <div class="co-w-thone-sap dropdown-setter country-field" data-setter="country">
                        <div class="master-table-text left-table-header" @click="sortTable('country')">Country</div>
                        <div class="master-table-opt"></div>
                        <button type="button" class="vs-con-dropdown parent-dropdown" data-getter="country">
                            <a href.prevent class="a-icon">
                                <i :class="(countrySearch.length > 0)?'filter-icon-i-active':'filter-icon-i'"></i>
                                <!-- <i class="vs-icon notranslate icon-scale more-vert-24px material-icons null"></i> -->
                            </a>
                        </button>
                        <Dropdown>
                            <ul>
                                <li>
                                    <input oninput="this.value = this.value.replace(/[-!$%^*_+@\s|~=`\\#{}\[\]:;'<>?,.\/]/g,'')"
                                    type="text" class="dropdown-input" placeholder="Filter"
                                           v-model="countrySearch"/>
                                </li>
                            </ul>
                        </Dropdown>
                    </div>
                    <div class="co-w-thone-sap dropdown-setter oe-field" data-setter="oe">
                        <div class="master-table-text left-table-header" @click="sortTable('oe')">OE</div>
                        <div class="master-table-opt"></div>
                        <button type="button" class="vs-con-dropdown parent-dropdown" data-getter="oe">
                            <a href.prevent class="a-icon">
                                <i :class="(oeSearch.length > 0)?'filter-icon-i-active':'filter-icon-i'"></i>
                                <!-- <i class="vs-icon notranslate icon-scale more-vert-24px material-icons null"></i> -->
                            </a>
                        </button>
                        <Dropdown>
                            <ul>
                                <li>
                                    <input oninput="this.value = this.value.replace(/[-!$%^*_+@\s|~=`\\#{}\[\]:;'<>?,.\/]/g,'')"
                                    type="text" class="dropdown-input" placeholder="Filter" v-model="oeSearch"/>
                                </li>
                            </ul>
                        </Dropdown>
                    </div>
                    <div class="co-w-thone-country dropdown-setter level-field" data-setter="level">
                        <div class="master-table-text left-table-header" @click="sortTable('level')">Level</div>
                        <div class="master-table-opt"></div>
                        <button type="button" class="vs-con-dropdown parent-dropdown" data-getter="level">
                            <a href.prevent class="a-icon">
                                <i :class="(levelSearch.length > 0)?'filter-icon-i-active':'filter-icon-i'"></i>
                                <!-- <i class="vs-icon notranslate icon-scale more-vert-24px material-icons null"></i> -->
                            </a>
                        </button>
                        <Dropdown>
                            <ul>
                                <li>
                                    <input oninput="this.value = this.value.replace(/[-!$%^*_+@\s|~=`\\#{}\[\]:;'<>?,.\/]/g,'')"
                                    type="text" class="dropdown-input" placeholder="Filter"
                                           v-model="levelSearch"/>
                                </li>
                            </ul>
                        </Dropdown>
                    </div>
                    <div class="co-w-thone-country dropdown-setter start-field" data-setter="start">
                        <div class="master-table-text left-table-header" @click="sortTable('start')">Start</div>
                        <div class="master-table-opt"></div>
                        <button type="button" class="vs-con-dropdown parent-dropdown" data-getter="start">
                            <a href.prevent class="a-icon">
                                <i :class="(startSearch.length > 0)?'filter-icon-i-active':'filter-icon-i'"></i>
                                <!-- <i class="vs-icon notranslate icon-scale more-vert-24px material-icons null"></i> -->
                            </a>
                        </button>
                        <Dropdown class="date-dropdown-box view-header-table-view">
                            <div class="date-close-pos">
                                <input type="text" disabled class="dropdown-input dropdown-input-date"
                                       placeholder="Search" v-model="startSearch">
                                <a class="close-button" @click.prevent="startSearch = null; datePickerOnChange()"></a>
                            </div>
                            <vue-date-picker v-model="start" @onChange="datePickerOnChange()" visible no-header inline
                                             validate></vue-date-picker>

                        </Dropdown>
                    </div>
                    <div class="co-w-thone-country dropdown-setter end-field" data-setter="end">
                        <div class="master-table-text left-table-header" @click="sortTable('end')">End</div>
                        <div class="master-table-opt"></div>
                        <button type="button" class="vs-con-dropdown parent-dropdown" data-getter="end">
                            <a href.prevent class="a-icon">
                                <i :class="(endSearch.length > 0)?'filter-icon-i-active':'filter-icon-i'"></i>
                                <!-- <i class="vs-icon notranslate icon-scale more-vert-24px material-icons null"></i> -->
                            </a>
                        </button>
                        <Dropdown class="date-dropdown-box view-header-table-view">
                            <div class="date-close-pos">
                                <input type="text" disabled class="dropdown-input dropdown-input-date"
                                       placeholder="Search" v-model="endSearch">
                                <a class="close-button" @click.prevent="endSearch=null; datePickerOnChange()"></a>
                            </div>
                            <vue-date-picker v-model="end" @onChange="datePickerOnChange()" visible no-header inline
                                             validate></vue-date-picker>

                        </Dropdown>
                    </div>
                    <div class="co-w-thone-country dropdown-setter hrrate-field" data-setter="hrrate">
                        <div class="master-table-text left-table-header" @click="sortTable('rate')">HR.Rate</div>
                        <div class="master-table-opt"></div>
                        <button type="button" class="vs-con-dropdown parent-dropdown" data-getter="hrrate">
                            <a href.prevent class="a-icon">
                                <i :class="(rateSearch.length > 0)?'filter-icon-i-active':'filter-icon-i'"></i>
                                <!-- <i class="vs-icon notranslate icon-scale more-vert-24px material-icons null"></i> -->
                            </a>
                        </button>
                        <Dropdown>
                            <ul>
                                <li>
                                    <input oninput="this.value = this.value.replace(/[-!$%^*_+@\s|~=`\\#{}\[\]:;'<>?,.\/]/g,'')"
                                    type="text" class="dropdown-input" placeholder="Filter"
                                           :class="{'error-border':searchError.rate}"
                                           v-model="rateSearch"/>
                                </li>
                            </ul>
                        </Dropdown>
                    </div>
                    <div class="co-w-thone-country dropdown-setter timeleft-field right-pos-cell" data-setter="timeleft">
                        <div class="master-table-text left-table-header" @click="sortTable('time_left')">Time Left</div>
                        <div class="master-table-opt"></div>
                        <button type="button" class="vs-con-dropdown parent-dropdown" data-getter="timeleft">
                            <a href.prevent class="a-icon">
                                <i :class="(timeLeftSearch.length > 0)?'filter-icon-i-active':'filter-icon-i'"></i>
                                <!-- <i class="vs-icon notranslate icon-scale more-vert-24px material-icons null"></i> -->
                            </a>
                        </button>
                        <Dropdown>
                            <ul>
                                <li>
                                    <input oninput="this.value = this.value.replace(/[-!$%^*_+@\s|~=`\\#{}\[\]:;'<>?,.\/]/g,'')"
                                    type="text" class="dropdown-input" placeholder="Filter"
                                           :class="{'error-border':searchError.time_left}"
                                           v-model="timeLeftSearch"/>
                                </li>
                            </ul>
                        </Dropdown>
                    </div>
                </div>
            </div>
            <div class="master-table master-report-table master-table-loaded" v-bar id="engagement-scroll-table">
                <scroll-sync group="report" ref="verticalscrollset" vertical>
                    <scroll-sync group="two" vertical>
                        <table-loader v-if="isLoadingMoreRows"></table-loader>
                        <template v-for="(relation, index) in relations">
                            <engagement-relation-row :key="index" :relation="relation"/>
                        </template>
                        <div class="no-item" v-if="relations.length < 1">No items found !</div>
                    </scroll-sync>
                     <div class="no-item" v-if="relations.length<1">No items found !</div>
                </scroll-sync>
            </div>
        </div>
        <!-- bottom -->
        <div class="table-results">
            <div class="table-result">
                <p class="left-td bottom-left-heading">Total</p>
            </div>
        </div>
    </div>
</template>

<script>
    const EngagementRelationRow = () => import("./EngagementRelationRow");
    const ReportHeader = () => import("../ReportHeader");
    const Dropdown = () => import('../../../common/Dropdown');
    const TableLoader = () => import("../../../common/TableLoader");

    import settings from "../../../../config/settings";
    import searchKeys from "../../../../config/searchKeys";
    import _ from 'lodash';
    import {VueDatePicker} from "@mathieustan/vue-datepicker";

    export default {
        name: "CustomerEngagementRelation",
        data() {
            return {
                masterTableWidth: 0,
                loadMore: true,
                timeout: 0,
                searchError: {
                    rate: false,
                    time_left: false
                },
                start: null,
                end: null
            }
        },
        components: {
            TableLoader,
            EngagementRelationRow,
            ReportHeader,
            Dropdown,
            VueDatePicker
        },
        computed: {
            /**
             * Bench report cosultant list from store
             */
            relations: function () {
                return this.$store.state.reports.customerEngagementRelations;
            },
            /**
             * Get the bench overview filter data from store
             */
            filter: function () {
                return this.$store.state.reports.customerEngagementFilter;
            },
            /**
             * if loading more rows for bench overview
             */
            isLoadingMoreRows: function () {
                return this.$store.state.reports.loadingCustomerEngagementRows;
            },
            /**
             * Model binding for consultant search
             */
            consultantSearch: {
                get: function () {
                    // get the filters array from the store
                    let filters = this.$store.state.reports.customerEngagementFilter.filterParams;
                    // get the current filter by matching the field name
                    let currentFilterObject = filters.find(f => f.fieldName === searchKeys.consultant);
                    // if the filter exists, then return the value else empty
                    return currentFilterObject ? currentFilterObject.value : '';
                },
                set: function (value) {
                    let data = {
                        key: searchKeys.consultant,
                        value: value
                    };
                    this.$store.commit("setCustomerEngagementSearchData", data);
                }
            },
            countrySearch: {
                get: function () {
                    // get the filters array from the store
                    let filters = this.$store.state.reports.customerEngagementFilter.filterParams;
                    // get the current filter by matching the field name
                    let currentFilterObject = filters.find(f => f.fieldName === searchKeys.country);
                    // if the filter exists, then return the value else empty
                    return currentFilterObject ? currentFilterObject.value : '';
                },
                set: function (value) {
                    let data = {
                        key: searchKeys.country,
                        value: value
                    };
                    this.$store.commit("setCustomerEngagementSearchData", data);
                }
            },
            timeLeftSearch: {
                get: function () {
                    // get the filters array from the store
                    let filters = this.$store.state.reports.customerEngagementFilter.filterParams;
                    // get the current filter by matching the field name
                    let currentFilterObject = filters.find(f => f.fieldName === searchKeys.time_left);
                    // if the filter exists, then return the value else empty
                    return currentFilterObject ? currentFilterObject.value : '';
                },
                set: function (value) {
                    let data = {
                        key: searchKeys.time_left,
                        value: value
                    };
                    this.$store.commit("setCustomerEngagementSearchData", data);
                }
            },
            projectSearch: {
                get: function () {
                    // get the filters array from the store
                    let filters = this.$store.state.reports.customerEngagementFilter.filterParams;
                    // get the current filter by matching the field name
                    let currentFilterObject = filters.find(f => f.fieldName === searchKeys.project);
                    // if the filter exists, then return the value else empty
                    return currentFilterObject ? currentFilterObject.value : '';
                },
                set: function (value) {
                    let data = {
                        key: searchKeys.project,
                        value: value
                    };
                    this.$store.commit("setCustomerEngagementSearchData", data);
                }
            },
            levelSearch: {
                get: function () {
                    // get the filters array from the store
                    let filters = this.$store.state.reports.customerEngagementFilter.filterParams;
                    // get the current filter by matching the field name
                    let currentFilterObject = filters.find(f => f.fieldName === searchKeys.level);
                    // if the filter exists, then return the value else empty
                    return currentFilterObject ? currentFilterObject.value : '';
                },
                set: function (value) {
                    let data = {
                        key: searchKeys.level,
                        value: value
                    };
                    this.$store.commit("setCustomerEngagementSearchData", data);
                }
            },
            startSearch: {
                get: function () {
                    // get the filters array from the store
                    let filters = this.$store.state.reports.customerEngagementFilter.filterParams;
                    // get the current filter by matching the field name
                    let currentFilterObject = filters.find(f => f.fieldName === searchKeys.start);
                    // if the filter exists, then return the value else empty
                    return currentFilterObject ? currentFilterObject.value : '';
                },
                set: function (value) {
                    let data = {
                        key: searchKeys.start,
                        value: value
                    };
                    this.$store.commit("setCustomerEngagementSearchData", data);
                }
            },
            endSearch: {
                get: function () {
                    // get the filters array from the store
                    let filters = this.$store.state.reports.customerEngagementFilter.filterParams;
                    // get the current filter by matching the field name
                    let currentFilterObject = filters.find(f => f.fieldName === searchKeys.end);
                    // if the filter exists, then return the value else empty
                    return currentFilterObject ? currentFilterObject.value : '';
                },
                set: function (value) {
                    let data = {
                        key: searchKeys.end,
                        value: value
                    };
                    this.$store.commit("setCustomerEngagementSearchData", data);
                }
            },
            rateSearch: {
                get: function () {
                    // get the filters array from the store
                    let filters = this.$store.state.reports.customerEngagementFilter.filterParams;
                    // get the current filter by matching the field name
                    let currentFilterObject = filters.find(f => f.fieldName === searchKeys.rate);
                    // if the filter exists, then return the value else empty
                    return currentFilterObject ? currentFilterObject.value : '';
                },
                set: function (value) {
                    let data = {
                        key: searchKeys.rate,
                        value: value
                    };
                    this.$store.commit("setCustomerEngagementSearchData", data);
                }
            },
            /**
             * Model binding for customer search
             */
            customerSearch: {
                get: function () {
                    // get the filters array from the store
                    let filters = this.$store.state.reports.customerEngagementFilter.filterParams;
                    // get the current filter by matching the field name
                    let currentFilterObject = filters.find(f => f.fieldName === searchKeys.customer);
                    // if the filter exists, then return the value else empty
                    return currentFilterObject ? currentFilterObject.value : '';
                },
                set: function (value) {
                    let data = {
                        key: searchKeys.customer,
                        value: value
                    };
                    this.$store.commit("setCustomerEngagementSearchData", data);
                }
            },
            /**
             * Model binding for OE search
             */
            oeSearch: {
                get: function () {
                    // get the filters array from the store
                    let filters = this.$store.state.reports.customerEngagementFilter.filterParams;
                    // get the current filter by matching the field name
                    let currentFilterObject = filters.find(f => f.fieldName === searchKeys.oe);
                    // if the filter exists, then return the value else empty
                    return currentFilterObject ? currentFilterObject.value : '';
                },
                set: function (value) {
                    let data = {
                        key: searchKeys.oe,
                        value: value
                    };
                    this.$store.commit("setCustomerEngagementSearchData", data);
                }
            },
            today: function () {
                let today = new Date();
                let dd = String(today.getDate()).padStart(2, '0');
                let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
                let yyyy = today.getFullYear();
                today = mm + '/' + dd + '/' + yyyy;
                return today;
            },
        },
        beforeMount() {
            this.requestApis();
        },
        methods: {
            /**
             * Request for data
             */
            requestApis: function () {
                // let filter = this.initFilter();
                // this.$store.dispatch("fetchBenchReport", filter);
            },
            initFilter: function () {
                let filter = _.cloneDeep(this.filter);
                filter.pageNumber = 1;
                filter.pageSize = settings.initial_forecast_row_count;
                return filter;
            },
            /**
             * set the table width
             */
            setTableWidth: function () {
                setTimeout(() => {
                    let element = document.querySelector('.report-allocations .gm-scroll-view');
                    if (element) {
                        this.masterTableWidth = element.scrollWidth;
                    }
                }, 200);
            },
            /**
             * Handle the scroll event on report relation section
             * Get the scroll height and on limit, fetch data
             */
            handleScroll: function () {
                // get the parent element
                let parent = document.getElementById('engagement-scroll-table');
                // get the child element having scroll
                let child = parent.getElementsByClassName('scroll-sync-container');
                // get the first child, first having the scroll
                let firstChild = child[0];
                // on scrolling the child
                firstChild.addEventListener('scroll', () => {
                    // get the scroll height
                    let height = firstChild.scrollHeight - firstChild.scrollTop;
                    console.log(height)
                    // scrolled down
                    if (height <= settings.load_more_height_report) {
                        // load more data
                        this.loadMoreResults();
                    }
                })
            },
            /**
             * Load more report data
             */
            loadMoreResults: function () {
                if (this.loadMore) {
                    this.loadMore = false;
                    this.$store.dispatch("fetchMoreCustomerEngagement").then(
                        () => {
                            this.loadMore = true;
                        }
                    );
                }
            },
            /**
             * Request with the search result once the user stopped typing
             */
            submitSearchResult: function () {
                let filter = _.cloneDeep(this.filter);
                filter.pageNumber = 1;
                filter.pageSize = settings.initial_forecast_row_count;
                clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                    // fetch the bench report with the search data
                    this.$store.dispatch("fetchCustomerEngagementReport", filter);
                    this.$store.dispatch("fetchReportAggregates", filter);
                }, 700);
            },
            /**
             * Sort the table on click
             */
            sortTable: function (column) {
                let rowCount = settings.initial_forecast_row_count;
                //clone the filter
                let filter = this.filter;
                let filterData = _.cloneDeep(filter);
                // if no sort set or sort set for another column
                if (!filter.sortColumn || filter.sortColumn !== searchKeys[column]) {
                    this.$store.commit("setCustomerEngagementSort", {column: searchKeys[column], order: 'ASC'});
                    filterData.sortColumn = searchKeys[column];
                    filterData.sortOrder = 'ASC';
                } else if (filter.sortColumn === searchKeys[column] && filter.sortOrder === 'ASC') {
                    this.$store.commit("setCustomerEngagementSort", {column: searchKeys[column], order: 'DESC'});
                    filterData.sortColumn = searchKeys[column];
                    filterData.sortOrder = 'DESC';
                } else if (filter.sortColumn === searchKeys[column] && filter.sortOrder === 'DESC') {
                    this.$store.commit("setCustomerEngagementSort", {column: searchKeys[column], order: 'ASC'});
                    filterData.sortColumn = searchKeys[column];
                    filterData.sortOrder = 'ASC';
                }
                if (this.relations && this.relations.length && this.relations.length > settings.initial_forecast_row_count) {
                    rowCount = this.relations.length;
                }
                // set row count
                filterData.pageSize = rowCount;
                // set the page number to 1
                filterData.pageNumber = 1;
                // request data with filter
                this.$store.dispatch("fetchCustomerEngagementReport", filterData);

                //Close picker once the action is completed.
                this.datePickerOnChange();
            },

            /**
             * Mouse wheel on right table should scroll the horizontal area.
             * @constructor
             */
            HeadHorizontalScroll: function () {
                let ScrollElement = this.$refs.masterHeadScroll,
                    scrollableElement = document.querySelector('.report-alloc-benchoverview .gm-scroll-view'),
                    i = 0;

                //Mouse wheel and scroll event
                ScrollElement.addEventListener('wheel', function (e) {
                    //When dragging to left side
                    if (e.deltaY < 0 && !e.shiftKey) {
                        if (i >= 0) {
                            //if Scroll left == 0
                            scrollableElement.scrollLeft = i;
                            i = i - 50;
                        } else {
                            i = 0;
                        }

                    }
                    //Mouse wheel and horizontal scroll for allocation's headers
                    else if (e.deltaY > 0 && !e.shiftKey) {
                        if (i <= scrollableElement.scrollWidth) {
                            //if Scroll left !== end of the div
                            scrollableElement.scrollLeft = i;
                            i = i + 50;
                        } else {
                            i = scrollableElement.scrollWidth
                        }
                    }

                })
            },
            updateEngagementData: function () {
                let filter = _.cloneDeep(this.filter);
                filter.pageNumber = 1;
                filter.pageSize = this.relations && this.relations.length > settings.initial_forecast_row_count ? this.relations.length : settings.initial_forecast_row_count;
                this.$store.dispatch("fetchCustomerEngagementReport", filter);
                this.$store.dispatch("fetchReportAggregates", filter);
            },
            exportExcel: function () {
                let filter = _.cloneDeep(this.filter);
                filter.pageNumber = 1;
                filter.pageSize = this.relations && this.relations.length > settings.initial_forecast_row_count ? this.relations.length : settings.initial_forecast_row_count;
                // send request
                this.$store.dispatch("exportCustomerEngagement", filter);
            },
            /* Custom horizontal scroll function when resizing the page to laptop or tab view */
            customHorizontalbar: function () {
                let oldy = 0;
                //Fixed width


                //Get scrollable div

                let parentScrollElement;
                if (this.$refs.verticalscrollset.$el != null && this.$refs.verticalscrollset.$el != undefined) {
                    parentScrollElement = this.$refs.verticalscrollset.$el;
                }


                // let parentScrollElement = this.$refs.verticalscrollset.$el;
                let customScrollElement = parentScrollElement.querySelector('.scroll-sync-container');
                customScrollElement.classList.add('qtime-h-scroll');
                /*Now, <div class="scroll-sync-container qtime-h-scroll"></div> is the scrollable div */

                let customScrollElementWidth = customScrollElement.getBoundingClientRect(),
                    customScrollElementRemainWidth = 0;


                //Create div and scroll panel for the scrollable div
                let scrollableFnWrap = document.createElement('div');
                scrollableFnWrap.id = "qtime-h-scroll-bar";
                scrollableFnWrap.classList.add('qtime-h-scroll-bar-class');
                customScrollElement.appendChild(scrollableFnWrap);

                //Create scroll thumb and append it into the  `scrollableFnWrap` div
                let scrollableThumb = document.createElement('div');
                scrollableThumb.id = "q-time-scroll-thumb";
                //scrollableThumb.setAttribute('draggable', true);
                scrollableFnWrap.appendChild(scrollableThumb);

                //setting thumb width, using thumb width function
                setTimeout(function () {
                    thumbWidthFn();
                }, 500);


                //Thumb scroll event, used mousedown, mouseup and mousemove.    
                scrollableThumb.onmousedown = function (e) {
                    let shiftX = e.clientX - scrollableThumb.getBoundingClientRect().left;
                    moveAt(e.pageX, e.pageY);
                    oldy = e.pageY;

                    //Move function, it scrolls the area.
                    function moveAt(pageX) {
                        customScrollElement.scrollLeft = pageX - shiftX;
                        scrollableThumb.style.transform = "translateX(" + customScrollElement.scrollLeft + "px)";
                    }

                    //EventLintener trigger function
                    function onMouseMove(e) {
                        moveAt(e.pageX, e.pageY);
                    }

                    //Mouse move event
                    document.addEventListener('mousemove', onMouseMove);

                    //Mouseup event, after scolling and once the mouse is up, set the position and points.
                    document.addEventListener('mouseup', () => {
                        document.removeEventListener('mousemove', onMouseMove);

                    })
                }

                // Horizontal scroll support event method.
                scrollableThumb.ondragstart = function () {
                    return false;
                }

                //Call the method when resize event happens.
                customScrollElement.addEventListener('scroll', function (e) {
                    SyncScrollDrag(e);
                });


                // Sync scroll, Both area scroll and thumb scroll should sync.
                function SyncScrollDrag() {
                    scrollableThumb.style.transform = "translateX(" + customScrollElement.scrollLeft + "px)";
                }

                //Thumb width function 
                function thumbWidthFn() {
                    if (customScrollElement.scrollWidth >= 692) {
                        //Remaining width
                        customScrollElementRemainWidth = customScrollElement.scrollWidth - customScrollElementWidth.width;
                        //adding thumb size as per screen size & scrollWidth calculation
                        scrollableThumb.style.width = (customScrollElementWidth.width - customScrollElementRemainWidth) + "px";
                    }

                    // For small screens (< 900)
                    if (customScrollElementWidth.width < 692) {
                        scrollableThumb.style.width = ((customScrollElement.scrollWidth - customScrollElementWidth.width) / 10) + "px";
                    }

                }
            },

            //Remove scrollbar and thumb as init function.
            //to avoid duplication when resizing
            clearAllElements: function () {
                try {
                    // let clearingNavBar = document.getElementById('qtime-h-scroll-bar');
                    let clearingNavBar = document.querySelectorAll('.qtime-h-scroll-bar-class');
                    clearingNavBar.forEach((i) => {
                        i.remove();
                    });

                } catch (e) {
                    console.log(e);
                }

            },

            //call listeners
            callListeners: function () {
                this.clearAllElements();
                
                // this.customHorizontalbar();
            },


            datePickerOnChange: function () {
                //Closing the popup when a value is selected
                if (document.querySelectorAll('.view-header-table-view') != undefined || document.querySelectorAll('.view-header-table-view') != null) {
                    document.querySelectorAll('.view-header-table-view').forEach((elem) => {
                        elem.classList.remove('open-d');
                    });
                }
            },
            
            wrappingLap: function(){
                // this.$refs.table-wrapper-lap
                var el = this.$refs.tableWrapperLap;
                if(!el.closest('.table-wrapper-outer')){
                    
                    var wrapper = document.createElement('div');
                    wrapper.classList.add('table-wrapper-outer');
                    el.parentNode.insertBefore(wrapper, el);
                    wrapper.appendChild(el);
                }
            }

        },
        updated() {
            this.setTableWidth(); 
        },
        created() {
            this.start = this.today;
            this.end = this.today;
        },

        beforeDestroy() {
            //Removing resize event listener in beforeDestroy() hook
            window.removeEventListener("resize", this.callListeners);
        },

        mounted() {
            this.handleScroll();
            setTimeout(() => {
                // this.customHorizontalbar();
            }, 800);
            
            this.wrappingLap();


            // OnResize event, calling drag function.
            window.addEventListener("resize", this.callListeners);
            /* Header and table scroll should always...*/
            //Relation scroll when resizing
            let scrollElement = this.$refs.verticalscrollset.$el;
            let overflowContainer = scrollElement.querySelector('.scroll-sync-container');
            let scrollElementHead = document.querySelector('.master-t-head-b');

            //Sync scroll in laptop view
            overflowContainer.addEventListener('scroll', function (node) {
                scrollElementHead.scrollLeft = node.target.scrollLeft;
            });

            //sync scroll in laptop view
            scrollElementHead.addEventListener('scroll', function (node) {
                overflowContainer.scrollLeft = node.target.scrollLeft;
            });


        },
        watch: {
            allocations: function () {
                this.setTableWidth();
            },
            customerSearch: function (value) {
                if (!value || !/^\s+$/.test(value)) {
                    this.submitSearchResult()
                }
            },
            consultantSearch: function (value) {
                if (!value || !/^\s+$/.test(value)) {
                    this.submitSearchResult()
                }
            },
            projectSearch: function (value) {
                if (!value || !/^\s+$/.test(value)) {
                    this.submitSearchResult()
                }
            },
            countrySearch: function (value) {
                if (!value || !/^\s+$/.test(value)) {
                    this.submitSearchResult()
                }
            },
            oeSearch: function (value) {
                if (!value || !/^\s+$/.test(value)) {
                    this.submitSearchResult()
                }
            },
            levelSearch: function (value) {
                if (!value || !/^\s+$/.test(value)) {
                    this.submitSearchResult()
                }
            },
            startSearch: function (value) {
                if (!value || !/^\s+$/.test(value)) {
                    this.submitSearchResult()
                }
            },
            endSearch: function (value) {
                if (!value || !/^\s+$/.test(value)) {
                    this.submitSearchResult()
                }
            },
            rateSearch: function (value) {
                if (!value || /^(\d)+(.\d+)?$/.test(value)) {
                    this.searchError.rate = false;
                    this.submitSearchResult()
                } else this.searchError.rate = !!value;
            },
            timeLeftSearch: function (value) {
                if (!value || !/^\s+$/.test(value)) {
                    this.searchError.time_left = false;
                    this.submitSearchResult()
                } else this.searchError.time_left = !!value;
            },
            start: function (value, prevValue) {
                if (prevValue) {
                    this.startSearch = value;
                }
            },
            end: function (value, prevValue) {
                if (prevValue) {
                    this.endSearch = value;
                }
            }
        }
    }
</script>

<style scoped>

    .scroll-sync-container.vb-content {
        border-bottom: 1px solid #dee1e3;
    }

    /* Header cols */
    .customer-engagement {
        width: 1015px;

    }

    @media screen and (min-width: 1560px) {
        .customer-engagement {
            min-width: 1015px;
        }
    }

    .customer-field {
        width: 163px;
        min-width: 163px;
        padding-left: 43px;
    }

    .consultant-field {
        width: 122px;
        min-width: 122px;
    }

    .project-field {
        width: 96px;
        min-width: 96px;
    }

    .country-field {
        width: 101px;
        min-width: 101px;
    }

    .oe-field {
        width: 90px;
        min-width: 90px;
    }

    .level-field {
        width: 82px;
        min-width: 82px;
    }

    .start-field {
        width: 82px;
        min-width: 82px;
    }

    .end-field {
        width: 82px;
        min-width: 82px;
    }

    .hrrate-field {
        width: 94px;
        min-width: 94px;
    }

    .timeleft-field {
        width: 103px;
        min-width: 103px;
    }


    #engagement-scroll-table {
        /* height: calc(100vh - 288px);
        height: -webkit-calc(100vh - 288px);
        height: -moz-calc(100vh - 288px);
        max-height: calc(100vh - 288px);
        max-height: -webkit-calc(100vh - 288px);
        max-height: -moz-calc(100vh - 288px); */


        height: calc(100vh - 248px);
        height: -webkit-calc(100vh - 248px);
        height: -moz-calc(100vh - 248px);

        max-height: calc(100vh - 248px);
        max-height: -webkit-calc(100vh - 248px);
        max-height: -moz-calc(100vh - 248px);

        min-height: calc(100vh - 248px);
        min-height: -webkit-calc(100vh - 248px);
        min-height: -moz-calc(100vh - 248px);
    }


    /* @media screen and (max-width: 1560px){
           #engagement-scroll-table {
                height: calc(100vh - 269px);
                height: -webkit-calc(100vh - 269px);
                height: -moz-calc(100vh - 269px);
    
                max-height: calc(100vh - 269px);
                max-height: -webkit-calc(100vh - 269px);
                max-height: -moz-calc(100vh - 269px);
    
                min-height: calc(100vh - 269px);
                min-height: -webkit-calc(100vh - 269px);
                min-height: -moz-calc(100vh - 269px);
            }
    }
     */
        @media screen and (max-width: 1560px){
            #engagement-scroll-table {
                height: calc(100vh - 269px);
                height: -webkit-calc(100vh - 269px);
                height: -moz-calc(100vh - 269px);
    
                max-height: calc(100vh - 269px);
                max-height: -webkit-calc(100vh - 269px);
                max-height: -moz-calc(100vh - 269px);
    
                min-height: calc(100vh - 269px);
                min-height: -webkit-calc(100vh - 269px);
                min-height: -moz-calc(100vh - 269px);
            }
            
        }

    .error-border {
        border: 1px solid red;
    }


</style>